{
  "title": "Izinkan akses ke lokasi Anda?",
  "body": "Dengan mengizinkan akses ke lokasi Anda, kami dapat memastikan Anda telah tiba di fasilitas untuk check-in",
  "disagree": "Tidak setuju",
  "agree": "Setuju"
}
